import { Dialog, Grid } from '@material-ui/core'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import ReactSVG from 'react-svg'

import {
  Chart,
  CongratulationsModal,
  EvaluationWarningModal,
  ProgressionEvaluationModal,
  ShareWithTeacherModal,
  // ScoreLegend,
  Statistic
} from 'components'
import allAbilities from 'data/abitilies'
import { Ability } from 'data/abitilies/interfaces/IAbilityData'
import ITalentsData from 'data/abitilies/interfaces/ITalentsData'
import FormType from 'data/questionnaires/FormType'
import { _route } from 'routes/config'
import { getGamesCount } from 'services/games'
import { getQuestionnairesCount } from 'services/questionnaires'
import AbilityInfo, { IAbilityKey } from './AbilityInfo'

import {
  Button,
  ButtonPure,
  Colors,
  Icon,
  Typography
} from '@giantleap/components-library'
import CrossIcon from 'assets/img/cross.svg'
import { authRef } from 'config'
import { get } from 'lodash'
import mixpanel from 'mixpanel-browser'
import * as moment from 'moment'
import { AddChildWarnModal } from 'pages/AddChild/WarnModal/addChildWarnModal'
import { bindActionCreators } from 'redux'
import { isEducator } from 'services/user'
import { getAge } from 'services/utils'
import * as PatientActions from 'store/patients/actions'
import styles from './style.module.scss'
import './style.scss'

type ProgEvalModalType = 'questionnaires' | 'games' | null
interface IReduxStateProps {
  userAuth
  user: any
  currentPatient: any
  plusUser: any
}

interface IReduxDispatchProps {
  PatientsLib: any
}

interface IProps
  extends IReduxStateProps,
    IReduxDispatchProps,
    RouteComponentProps {
  talentsChartData: ITalentsData[]
  openPlusOnlyPopup: () => void
  toggleHistoryModal: () => void
  activeDate?: number | string
  openShareModal: () => void
  role: 'educator' | 'parent' | 'careProffesional'
}

export interface IState {
  showMore: boolean
  selectedAbility: IAbilityKey
  progressionEvaluationModalOpen: boolean
  gameInstallationModalOpen: boolean
  evaluationWarningModalOpen: boolean
  progEvalModalType: ProgEvalModalType
  abilityKey: Ability | null
  isOpenShareModal: boolean
  isCongratulationsModalOpen: boolean
  isChildWarnModal: boolean
  isShareModalOpen: boolean
}

const exceptionsList = ['self-esteem', 'spatial']

class Content extends React.PureComponent<IProps, IState> {
  state: IState = {
    showMore: true,
    selectedAbility: '',
    progressionEvaluationModalOpen: false,
    gameInstallationModalOpen: false,
    evaluationWarningModalOpen: false,
    progEvalModalType: null,
    abilityKey: null,
    isOpenShareModal: false,
    isCongratulationsModalOpen: false,
    isChildWarnModal: false,
    isShareModalOpen: false
  }

  componentDidMount() {
    const {
      location: { hash },
      history: {
        location: { state }
      }
    } = this.props

    if (state) {
      const isChildWarnModal = get(state, 'isChildWarnModal', false)

      if (isChildWarnModal) {
        this.setState({ isChildWarnModal })
      } else {
        const isCongratulationsModalOpen = get(
          state,
          'isCongratulationsModalOpen',
          false
        )

        if (isCongratulationsModalOpen) {
          this.setState({ isCongratulationsModalOpen })
        }
      }
    }

    if (hash) {
      const h = hash.substring(1)

      this.setState({ selectedAbility: h })
    }
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    const { hash } = this.props.location
    const { hash: prevHash } = prevProps.location

    if (hash !== prevHash) {
      this.setState({ selectedAbility: hash ? hash.substring(1) : '' })
    }

    if (prevState.selectedAbility !== this.state.selectedAbility) {
      if (this.state.selectedAbility) {
        const uid = authRef.currentUser?.uid
        mixpanel.identify(uid)
        mixpanel.track('Accessed abilities details', {
          type: this.state.selectedAbility
        })
      }
    }
  }

  clearHashInURL = () => {
    const { history } = this.props

    history.push(this.props.location.pathname)
  }

  toggleShowMore = () =>
    this.setState(prevState => ({ showMore: !prevState.showMore }))

  setSelectedAbility = (key: IAbilityKey) => {
    // add this condition because there are two swipers and this func is invoked twice every time
    // as result we will have with the back browser btn issue (double same path)
    if (key !== this.state.selectedAbility) {
      this.props.history.push(`${this.props.history.location.pathname}#${key}`)
    }
  }

  getProgEvalModalType = (type: Ability): 'questionnaires' | 'games' | null => {
    switch (type) {
      case Ability.attention:
      case Ability.math:
      case Ability.memory:
      case Ability.spatial:
      case Ability.executiveFunctions:
        return 'games'

      case Ability.motor:
      case Ability.selfEsteem:
      case Ability.social:
      case Ability.language:
        return 'questionnaires'

      default:
        return null
    }
  }

  goToQuestionnaire = questionnaireName => {
    const { history, currentPatient } = this.props
    const currentAssessment = currentPatient.currentAssessment

    let formType
    if (questionnaireName === 'motor') {
      formType = currentPatient.assessments[currentAssessment]?.motor
        ?.gross_motor?.total_results.total_score
        ? FormType.fineMotor
        : FormType.grossMotor
    } else {
      formType = questionnaireName
    }
    history.push('/questionnaires', formType)
  }

  renderDefault = () => {
    const {
      talentsChartData,
      plusUser,
      openPlusOnlyPopup,
      activeDate,
      toggleHistoryModal,
      currentPatient,
      role
    } = this.props
    const { showMore } = this.state
    if (!talentsChartData) {
      return null
    }
    const goToPlus = () => openPlusOnlyPopup()

    talentsChartData.map(ability => {
      if (Number.isNaN(ability.value)) {
        ability.value = -1
      }
    })
    const shareWithTeacher = role === 'parent'

    return (
      talentsChartData && (
        <>
          {talentsChartData && talentsChartData.length > 0 && (
            <div className="abilities-chart-wrapper design-fixes">
              <Chart
                isPlusUser={plusUser}
                chartData={{
                  labels: talentsChartData.map(item => item.label),
                  values: talentsChartData.map(item => item.value)
                }}
                goToPlus={goToPlus}
                onClicks={talentsChartData.map(({ key, value }) => () => {
                  if (isEducator(role)) {
                    return
                  }
                  const abilityType = this.getProgEvalModalType(key as Ability)

                  value === -1
                    ? this.setState(
                        {
                          progEvalModalType: abilityType,
                          abilityKey: key as Ability
                        },
                        () => {
                          if (
                            currentPatient.currentAssessment !==
                            currentPatient.assessments.relevant_assessment
                          ) {
                            this.setEvaluationWarningModalOpen(true)
                            return
                          }

                          abilityType === 'games'
                            ? this.setState({
                                progressionEvaluationModalOpen: true
                              })
                            : this.goToQuestionnaire(key)
                        }
                      )
                    : this.setSelectedAbility(key)
                })}
                role={role}
              />
            </div>
          )}
          <div className="details-container mobile-container">
            {shareWithTeacher && (
              <div className="share-teacher-button">
                <Button
                  type="xl"
                  color="white"
                  onClick={() => this.openShareModal()}
                >
                  Share with {currentPatient.first_name}’s Teacher
                </Button>
              </div>
            )}
            <div className="buttons-wrapper">
              <div className="buttons-wrapper__item">
                <ButtonPure
                  afterIcon={
                    <Icon type="bottom-arrow" color={Colors.unselected} />
                  }
                  onClick={toggleHistoryModal}
                  baseClassName={styles.wrap}
                >
                  <Typography type="headline" size="small">
                    {moment.unix(Number(activeDate)).format('MMMM YYYY')}
                  </Typography>
                </ButtonPure>
              </div>
            </div>
            {showMore && (
              <div className="links-container design-fixes">
                {
                  // <ScoreLegend />
                }
                {talentsChartData.map((item, index) => {
                  return (
                    <Statistic
                      title={item.label}
                      key={item.key}
                      value={item.value}
                      plusUser={plusUser || exceptionsList.includes(item.key)}
                      openPlusOnlyPopup={openPlusOnlyPopup}
                      onClick={() =>
                        plusUser || exceptionsList.includes(item.key)
                          ? this.setSelectedAbility(item.key)
                          : goToPlus()
                      }
                    />
                  )
                })}
              </div>
            )}
          </div>
        </>
      )
    )
  }

  renderAbilityInfo = () => {
    const { talentsChartData, currentPatient, openPlusOnlyPopup } = this.props
    const { selectedAbility } = this.state
    const keys = talentsChartData.map(item => item.key)
    const abilities = allAbilities.filter(item => keys.includes(item.key))
    const currentAssessment = currentPatient && currentPatient.currentAssessment

    return (
      <Dialog
        open={!!selectedAbility}
        fullScreen={true}
        classes={{
          root: 'abilities-info-dialog',
          container: 'abilities-info-dialog__container',
          paper: 'abilities-info-dialog__paper'
        }}
      >
        <AbilityInfo
          talentMap={
            currentPatient?.assessments[currentAssessment].current_talent_map
          }
          relevantAssessment={currentAssessment}
          birhtDate={currentPatient.birth_date}
          currentKey={selectedAbility}
          redirect={this.setSelectedAbility}
          abilities={abilities}
          isPlusUser={this.props.plusUser}
          goToPlus={() => openPlusOnlyPopup()}
        />
        <div className="cross-icon" onClick={this.clearHashInURL}>
          <ReactSVG src={CrossIcon} />
        </div>
      </Dialog>
    )
  }

  renderProggressionEvaluationModal() {
    const { history, currentPatient } = this.props
    const gamesPath = _route.games(currentPatient.patientId)
    const gamesCount = getGamesCount(currentPatient)
    const questionnairesCount = getQuestionnairesCount(currentPatient)
    const {
      progEvalModalType,
      progressionEvaluationModalOpen,
      abilityKey
    } = this.state
    const haveDateLocked = !!currentPatient.assessments[
      currentPatient.currentAssessment
    ]?.date_locked

    const assessmentCompleted =
      (gamesCount === 0 && questionnairesCount === 0) || haveDateLocked

    const showGames =
      abilityKey === Ability.attention
        ? !!(
            assessmentCompleted ||
            questionnairesCount === 0 ||
            location.pathname === _route.games(currentPatient.patientId) ||
            gamesCount
          )
        : progEvalModalType === 'games'
    const showQuestionnaries =
      abilityKey === Ability.attention
        ? assessmentCompleted ||
          gamesCount === 0 ||
          location.pathname === _route.questionnaires(currentPatient.patientId)
        : progEvalModalType === 'questionnaires'

    const pushToGamesPage = () => {
      history.push(gamesPath, {
        userCameFromQuestionnaires: true
      })
    }

    return (
      progressionEvaluationModalOpen && (
        <ProgressionEvaluationModal
          age={getAge(currentPatient.birth_date)}
          open={progressionEvaluationModalOpen}
          questionnairesCount={questionnairesCount}
          gamesCount={gamesCount}
          showGames={showGames}
          showQuestionnaries={showQuestionnaries}
          onClose={() => {
            this.setState({ progressionEvaluationModalOpen: false })
          }}
          onSubmit={() => {
            if (showQuestionnaries) {
              history.replace('/questionnaires', true)
            }
            if (showGames) {
              const {
                history: { location }
              } = this.props

              location.state = {
                ...(location.state as object),
                fromModal: true
              }
              // uniweb
              // window.location.href = `uniwebview://action?cid=${currentPatient.patientId}&cname=${currentPatient.first_name}`
              pushToGamesPage()
            }
          }}
          history={history}
          relevantAssessment={currentPatient.assessments.relevant_assessment}
        />
      )
    )
  }

  setEvaluationWarningModalOpen(evaluationWarningModalOpen: boolean): void {
    this.setState({ evaluationWarningModalOpen })
  }

  renderEvaluationWarningModal() {
    const { evaluationWarningModalOpen } = this.state
    const { PatientsLib, currentPatient } = this.props

    return (
      <EvaluationWarningModal
        active={evaluationWarningModalOpen}
        setActive={s => this.setEvaluationWarningModalOpen(s)}
        onButtonClick={() => {
          if (currentPatient) {
            const {
              patientId,
              assessments: { relevant_assessment }
            } = currentPatient

            PatientsLib.setCurrentAssessment(
              patientId,
              relevant_assessment,
              () => {
                PatientsLib.updateCurrentPatient()
                this.setEvaluationWarningModalOpen(false)
              },
              (error: string) => console.error(error)
            )
          } else {
            console.error('currentPatient is', { currentPatient })
          }
        }}
      />
    )
  }

  onCloseCongratulationsModal() {
    this.setState({ isCongratulationsModalOpen: false })
  }

  onSubmitCongratulationsModal() {
    const {
      PatientsLib,
      currentPatient: { patientId },
      history
    } = this.props

    PatientsLib.setCurrentPatient(patientId, () => {
      this.sendChildIdToMixPanel()
      // redirect to tour
      history.push(_route.games(patientId, 1))
    })
  }

  sendChildIdToMixPanel = () => {
    console.log('attempt to sendChildIdToMixPanel')
    // const { mixpanel, patients, authData } = this.props
    // const { patientId } = this.state
    // const patient = patients.find(p => p.patientId === patientId)
    // mixpanel.identify(authData.uid)
    // mixpanel.people.set({
    //   [`$child_${patients.indexOf(patient) + 1}_id`]: patientId
    // })
  }

  renderCongratulationsModal() {
    const { isCongratulationsModalOpen } = this.state

    return (
      isCongratulationsModalOpen && (
        <CongratulationsModal
          open={isCongratulationsModalOpen}
          onClose={() => this.onCloseCongratulationsModal()}
          onSubmit={() => this.onSubmitCongratulationsModal()}
        />
      )
    )
  }

  onCloseChildWarnModal() {
    this.setState({ isChildWarnModal: false, isCongratulationsModalOpen: true })
  }

  renderChildWarnModal() {
    const { isChildWarnModal } = this.state

    return (
      <AddChildWarnModal
        open={isChildWarnModal}
        onClose={() => this.onCloseChildWarnModal()}
      />
    )
  }

  setActiveShareModal(status: boolean) {
    this.setState({ isShareModalOpen: status })
  }

  openShareModal() {
    const { userAuth } = this.props
    this.setActiveShareModal(true)
    mixpanel.identify(userAuth.uid)
    mixpanel.track('Clicked Share with Educator')
  }

  renderShareWithTeacher() {
    const {
      user: { full_name },
      currentPatient,
      userAuth: { uid }
    } = this.props
    const { isShareModalOpen } = this.state
    return (
      <ShareWithTeacherModal
        open={isShareModalOpen}
        setActive={(status: boolean) => this.setActiveShareModal(status)}
        userName={full_name}
        currentPatient={currentPatient}
        userId={uid}
      />
    )
  }

  render() {
    const { selectedAbility } = this.state

    return (
      <>
        <Grid className="talents-tab page-min-content">
          {selectedAbility ? this.renderAbilityInfo() : this.renderDefault()}
          {this.renderProggressionEvaluationModal()}
          {this.renderEvaluationWarningModal()}
          {this.renderCongratulationsModal()}
          {this.renderChildWarnModal()}
          {this.renderShareWithTeacher()}
        </Grid>
      </>
    )
  }
}

const mapDispatchToProps = (dispatch): IReduxDispatchProps => {
  return {
    PatientsLib: bindActionCreators(PatientActions, dispatch)
  }
}

const mapStateToProps = state => {
  return {
    userAuth: state.user.auth,
    user: state.user.data,
    currentPatient: state.patients.currentPatient,
    plusUser: state.plus_user.isPlusUser
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Content))



// WEBPACK FOOTER //
// ./src/pages/PatientDetails/Abilities/index.tsx